import KeepAlive from "react-activation"
import { useLocation, useNavigate } from "react-router-dom"
import { SActionBtn, SBack, SLowcodeList, STableActions } from "shj-components"
import config from './config.json';
import { useRef, useState } from "react";
import { authDict } from "shj-utils";
import { downloadExcel, evaluationRecordList } from "@/services/evaluateConfig";
import { addFn } from "./add";
import { addLikeFn } from "./addLike";
import { getBranchComponyList, getEnums } from "@/services/homeService";
import { dateFormat } from "@/utils/date";
import { message } from "antd";
import { getAuth } from '@/utils/auth'
const EvaluateRecord = () => {
    const listRef = useRef<any>();
    const history = useNavigate()
    const fetchList = (values: any) => {
        return new Promise(async (resolve, reject) => {
            try {
                const { current, pageSize, query, ...rest } = values;
                const { createdTime, evaluateTime, connectTime } = query || {};
                const [createdTimeStartWith, createdTimeEndWith] = createdTime || [];
                const [evaluationTimeStartWith, evaluationTimeEndWith] = evaluateTime || [];
                const [lastContactTimeStartWith, lastContactTimeEndWith] = connectTime || [];
                const timeQuery = {
                    createdTimeStartWith: createdTimeStartWith ? dateFormat(createdTimeStartWith, 'YYYY-MM-DD HH:mm:ss') : null,
                    createdTimeEndWith: createdTimeEndWith ? dateFormat(createdTimeEndWith, 'YYYY-MM-DD HH:mm:ss') : null,
                    evaluationTimeStartWith: evaluationTimeStartWith ? dateFormat(evaluationTimeStartWith, 'YYYY-MM-DD HH:mm:ss') : null,
                    evaluationTimeEndWith: evaluationTimeEndWith ? dateFormat(evaluationTimeEndWith, 'YYYY-MM-DD HH:mm:ss') : null,
                    lastContactTimeStartWith: lastContactTimeStartWith ? dateFormat(lastContactTimeStartWith, 'YYYY-MM-DD HH:mm:ss') : null,
                    lastContactTimeEndWith: lastContactTimeEndWith ? dateFormat(lastContactTimeEndWith, 'YYYY-MM-DD HH:mm:ss') : null,
                }
                const orderBys = [
                    {
                        "columnName": "id",
                        "asc": false
                    }
                ];
                const dataQuery = { queryCustomerInfo: true, orderBys, ...query, ...timeQuery }
                evaluationRecordList(current, pageSize, dataQuery).then(data => {
                    resolve(data)
                })
            } catch (e) {
                reject({ success: false });
            }
        });
    };
    // 赞点
    const onAddLike = async (record: any) => {
      addLikeFn({
        fn: () => {
          listRef.current.reload();
        },
        ...record,
        record,
      });
    };
    // 备注
    const onAdd = async (record: any) => {
      console.log('config', getAuth())
        addFn({
            fn: () => {
                listRef.current.reload();
            },
            ...record,
            record,
        });
    };
    const onExport = () => {
        const orderBys = [
            {
                "columnName": "id",
                "asc": false
            }
        ];
        const query = listRef.current.getSearch().getFieldsValue();
        const { createdTime, evaluateTime, connectTime } = query || {};
        const [createdTimeStartWith, createdTimeEndWith] = createdTime || [];
        const [evaluationTimeStartWith, evaluationTimeEndWith] = evaluateTime || [];
        const [lastContactTimeStartWith, lastContactTimeEndWith] = connectTime || [];
        const timeQuery = {
            createdTimeStartWith: createdTimeStartWith ? dateFormat(createdTimeStartWith, 'YYYY-MM-DD HH:mm:ss') : null,
            createdTimeEndWith: createdTimeEndWith ? dateFormat(createdTimeEndWith, 'YYYY-MM-DD HH:mm:ss') : null,
            evaluationTimeStartWith: evaluationTimeStartWith ? dateFormat(evaluationTimeStartWith, 'YYYY-MM-DD HH:mm:ss') : null,
            evaluationTimeEndWith: evaluationTimeEndWith ? dateFormat(evaluationTimeEndWith, 'YYYY-MM-DD HH:mm:ss') : null,
            lastContactTimeStartWith: lastContactTimeStartWith ? dateFormat(lastContactTimeStartWith, 'YYYY-MM-DD HH:mm:ss') : null,
            lastContactTimeEndWith: lastContactTimeEndWith ? dateFormat(lastContactTimeEndWith, 'YYYY-MM-DD HH:mm:ss') : null,
        }
        const dataQuery = { queryCustomerInfo: true, orderBys, ...query, ...timeQuery }

        const data = {
            "taskName": "评价分发数据",
            "reqParam": JSON.stringify(dataQuery),
            "taskCode": "DistributionRecordExcelImpl",
            "taskSource": "MEMBER",
            "taskRemark": "我的评价分发记录导出测试"
        }
        message.loading({ content: '导出中' })
        downloadExcel(data)
            .then(() =>{
                history('/main/download');
            })
            .catch(() => {
                message.error('导出失败')
            })
    }
    const getStatusOptions = () => {
        return new Promise(async (resolve) => {
            try {
                // 需求类型枚举
                const bizOpTypeEnum: any = await getEnums("plus-member", "com.shj.saas.plus.crm.enums.BizOpTypeEnum");
                const enabledList = [{ code: true, name: '是' }, { code: false, name: '否' }];
                const companyList: any = await getBranchComponyList();
                // 状态枚举
                const evaluationDistributionStatusEnum: any = await getEnums("plus-member", "com.shj.saas.plus.member.enums.EvaluationDistributionStatusEnum");
                resolve({
                    bizOpTypeEnum,
                    enabledList,
                    evaluationDistributionStatusEnum,
                    companyList
                });
            } catch (e) { }
        });
    };
    const extension = {
        request: { fetchList, getStatusOptions },
        events: { onExport },
        searchFormConfig: {
            labelCol: {
                xs: { span: 24 },
                sm: { span: 8 },
            },
            wrapperCol: {
                xs: { span: 24 },
                sm: { span: 16 },
            },
        },
        customRender: {
            codeRender(text, record: any) {
                return authDict['evalutionRecordDetail'] ? (
                    <div
                        onClick={() => toDetail(record)}
                        style={{ color: '#1677ff', cursor: 'pointer' }}
                    >
                        {text}
                    </div>
                ) : (
                    <div>{text}</div>
                )
            },
            pushConditionsDescRender(text: any, record: any) {
                return <span>{record.evaluationConfig.pushConditionsDesc}</span>
            },
            pushDemandTypeDescRender(text: any, record: any) {
                return <span>{record.evaluationConfig.pushDemandTypeDesc}</span>
            },
            nodeStatusRender(text: any) {
                return <span>{text ? '是' : '否'}</span>;
            },
            setAction(text: any, record: any) {
                return <STableActions>
                    {record.status === 'waitingReturnVisit'  && <SActionBtn
                        auth={'evalutionRecordEdit'}
                        onClick={() => {
                            history(`/config/evalutionRecord/edit/?id=${record?.id||""}`);
                        }}
                    >
                        处理
                    </SActionBtn>}
                    <SActionBtn
                        auth={'evalutionRecordRemark'}
                        onClick={() => { onAdd(record) }}
                    >
                        备注
                    </SActionBtn>
                  <SActionBtn
                    auth="evalutionRecordLike"
                    onClick={() => { onAddLike(record) }}
                  >
                    赞点
                  </SActionBtn>
                  {
                    record?.status === 'alreadyEvaluated' && (
                      <SActionBtn
                        auth={'evalutionRecordModify'}
                        disabled={record?.modifyTime}
                        onClick={() => {
                          history(`/config/evalutionRecord/edit/?id=${record?.id||""}&&isModify=true`);
                        }}
                      >
                        修改
                      </SActionBtn>
                    )
                  }
                </STableActions>
            },
        },
    };
    const toDetail = (record) => {
        history('/config/evalutionRecord/detail/' + record.id);
    };
    return <>
        <SBack title={`分发记录`}></SBack>
        <SLowcodeList
            config={config}
            ref={listRef} {...extension} searchMode="group" />
    </>
}
export default (props: any) => {
    return (
        <>
            <EvaluateRecord {...props} />
        </>
    )
}
